import { PaperClipOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, Row, Select, Tooltip } from 'antd';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { ENTER_GRIEVANCE_TYPE_MESSAGE, ENTER_REMARKS_MESSAGE, GRIEVANCE_MAX_LIMIT_VALIDATION_MESSAGE,
   GRIEVANCE_REMARKS_PLACEHOLDER, GRIEVANCE_REMARKS_RQUIRED_MESSAGE, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import '../grievance.less';
import { base64UrlDecode, centeredNotification } from '../../../utils/utility';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { GrievanceModel } from '../../../store/models/grievanceModel';
import GrievanceUploadFiles from '../GrievanceUploadFiles';
import { ReactComponent as Cross_Icon } from '../../../assets/images/svg/Grievance_Cross_Icon.svg';
import { handleRemoveFile } from '../../crm/inPatient/service/crmUtils';
import { isEmpty } from 'lodash';
import { GRIEVANCE_TYPE_PLACEHOLDER } from '../services/grievanceConstants';
import { UploadFile } from 'antd/lib/upload/interface';

interface IEditorResponse {
  payerEmailId: string;
  ccEmailIds?: string;
  subject?: string;
  emailBody?: string;
  onSubmit: any;
  isLoading?: any;
  ticketId?: any;
  setSelectedGrievance?: any;
  selectedGrievance?: any;
  id?: any;
}
const EditorResponse = (data: IEditorResponse): ReactElement => {
  const { payerEmailId, ccEmailIds, subject, emailBody = '', onSubmit, isLoading, setSelectedGrievance, selectedGrievance, id } = data;
  const [grievanceForm] = Form.useForm();
  const { lookUp: { allGrievances = [], grievanceLookup } } = useSelector((state: RootState): any => state || []);
  const [fileList, setFileList] = useState<any[]>([]);
  const { selectedClaimsList } = useSelector((state: RootState): GrievanceModel => state?.grievance || {});
  const selectedHosActions = base64UrlDecode(id).split('-');
  const selectedClaims = selectedHosActions?.map((hospActionId: string): any => selectedClaimsList?.[hospActionId]);
  const fileListRef = useRef<UploadFile<any>[]>([]);
  const { Option } = Select;
  useEffect((): any => {
    const grievanceFormData = {
      payerEmailId,
      payerEmailIdCC: ccEmailIds,
      subject,
      mailBody: emailBody,
    };
    grievanceForm.setFieldsValue(grievanceFormData);
  }, [data]);

  const saveInformation = (): any => {
    grievanceForm.validateFields().then((): any => {
      const remarks = grievanceForm.getFieldValue('remarks');
      if (remarks && selectedGrievance) {
        onSubmit({ selectedClaims, remarks, fileList });
      } else if (!selectedGrievance) {
        centeredNotification(ENTER_GRIEVANCE_TYPE_MESSAGE, 'error');
      } else if (!remarks) {
        centeredNotification(ENTER_REMARKS_MESSAGE, 'error');
      }
    });
  };

  const onFileChange = (files: any): any => {
    setFileList(files);
  };

  const onChangeGrievanceType = (value: any, payerMasterValue: any): any => {
    setSelectedGrievance(payerMasterValue);
  };

  const grievanceOptions = (): any => {
    return !isEmpty(allGrievances) ?
      allGrievances :
      grievanceLookup;
  };

  return (
    <div>
      <Row>
        <strong>Grievance Details
        </strong>
      </Row>
      <Divider dashed={true} />
      <div>
        <Form
          form={grievanceForm}
          layout="vertical"
          autoComplete={'off'}
        >
          <Row className="mt-sm" gutter={GUTTOR_SPACE}>
            <Col md={12}>
              <Form.Item name="grievanceType" label={<div className="font-input">Grievance Type</div>}>
                <Select allowClear={true} placeholder={GRIEVANCE_TYPE_PLACEHOLDER} onChange={(value: any): any => {
                  const selectedGrievanceReason = grievanceOptions()?.find(
                    (grievance: any): boolean => (grievance?.payerMasterId || grievance?.id) === value,
                  );
                  onChangeGrievanceType(value, (selectedGrievanceReason?.payerMasterValue || selectedGrievanceReason?.value));
                }}>
                  {grievanceOptions()?.map((grievance: any): any => (
                    <Option key={grievance?.payerMasterId || grievance?.id} value={grievance?.payerMasterId || grievance?.id}>
                      {grievance?.payerMasterValue || grievance?.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row className="mt-sm" gutter={GUTTOR_SPACE}>
            <Col md={24}>
              <Form.Item name="remarks" label={<div className="font-input">Remarks</div>} rules={[
                { required: true, message: GRIEVANCE_REMARKS_RQUIRED_MESSAGE },
                { max: 500, message: GRIEVANCE_MAX_LIMIT_VALIDATION_MESSAGE},
              ]}
              >
                <Input.TextArea
                  placeholder={GRIEVANCE_REMARKS_PLACEHOLDER}
                  rows={4}
                />
              </Form.Item>

              <GrievanceUploadFiles
                key="upload"
                setFileList={onFileChange}
                fileList={fileList}
                showUploadIcon={true}
                newGrievance={true}
                fileListRef={fileListRef}
              />
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            {(fileList?.length > 0) &&
              fileList.map((file: any): any => (
                <Col key={file?.uid} md={24} className="uploaded-file">
                  <PaperClipOutlined />&nbsp;{file?.name}
                  <Tooltip title="Remove">
                    <Cross_Icon
                      className="grievance-remove-file-icon"
                      onClick={(): any => handleRemoveFile(file, setFileList, fileListRef)}
                    />
                  </Tooltip>
                </Col>
              ))}
          </Row>
          <div className="button-position">
            <Button loading={isLoading} type="primary" className="ml-10" onClick={saveInformation}>Submit</Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default EditorResponse;
